export const refs = {
  btnHeaderEl: document.querySelector('.js-btn__header'),
  refLibreryHeaderEl: document.querySelector('.js-library__ref'),
  galleryEl: document.querySelector('.gallery'),
  btnGelleryQueueEl: document.querySelector('[data-action="queue"]'),
  btnGelleryWatchedEl: document.querySelector('[data-action="watched"]'),
  modalBtnParentEl: document.querySelector('.js-btnElement'),
};
export default {
  container: document.getElementById('pagination'),
  paginationWrap: document.querySelector('.wraper'),
  btnGoTop: document.querySelector('.btn-move-up'),
  toggleTheme: document.querySelector('.toggle-theme'),
};
